import { Mail, MapPin, Phone, Linkedin, Facebook, Instagram, Twitter } from 'lucide-react'
import CrateMark from './CrateMark'

const COLUMNS = {
  Services: [
    { name: 'Web design Melbourne', href: '#services' },
    { name: 'Google Business Profile', href: '#google-business-profile' },
    { name: 'Website maintenance', href: '#website-maintenance' },
    { name: 'Local SEO support', href: '#local-seo' },
    { name: 'Pricing', href: '#pricing' },
  ],
  Company: [
    { name: 'Recent work', href: '#work' },
    { name: 'About', href: '#about' },
    { name: 'Process', href: '#process' },
    { name: 'FAQ', href: '#faq' },
    { name: 'Contact', href: '#contact' },
  ],
}

const SOCIALS = [
  { icon: Linkedin, href: 'https://linkedin.com/company/crateweb', label: 'LinkedIn' },
  { icon: Facebook, href: 'https://facebook.com/crateweb', label: 'Facebook' },
  { icon: Instagram, href: 'https://instagram.com/crateweb', label: 'Instagram' },
  { icon: Twitter, href: 'https://twitter.com/crateweb', label: 'Twitter / X' },
]

const Footer = () => {
  const year = new Date().getFullYear()
  const go = (href: string) => document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' })

  return (
    <footer className="relative overflow-hidden bg-ink text-cream">
      <div className="bg-fine-grid pointer-events-none absolute inset-0 opacity-[0.05]" />
      <div className="relative mx-auto max-w-container px-5 lg:px-8">
        <div className="grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-[1.6fr_1fr_1fr_1fr]">
          {/* Brand */}
          <div>
            <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="flex items-center gap-2.5">
              <CrateMark light className="h-9 w-9" />
              <span className="font-display text-2xl font-extrabold">
                Crate<span className="text-gold-bright">Web</span>
              </span>
            </button>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-cream/60">
              Fixed-price websites, Google Business Profile support, local SEO setup, and maintenance
              for Melbourne small businesses.
            </p>
            <div className="mt-6 space-y-3 text-sm">
              <a href="mailto:hello@crateweb.com.au" className="flex items-center gap-3 text-cream/70 transition-colors hover:text-cream">
                <Mail className="h-4 w-4 text-gold-bright" /> hello@crateweb.com.au
              </a>
              <a href="tel:0450692980" className="flex items-center gap-3 text-cream/70 transition-colors hover:text-cream">
                <Phone className="h-4 w-4 text-gold-bright" /> 0450 692 980
              </a>
              <span className="flex items-center gap-3 text-cream/70">
                <MapPin className="h-4 w-4 text-gold-bright" /> Melbourne, Australia
              </span>
            </div>
            <div className="mt-6 flex gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="grid h-10 w-10 place-items-center rounded-full bg-cream/10 text-cream transition-colors hover:bg-gold hover:text-white"
                >
                  <s.icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {Object.entries(COLUMNS).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-display text-sm font-bold uppercase tracking-wider text-cream/50">{title}</h4>
              <ul className="mt-4 space-y-3">
                {links.map((l) => (
                  <li key={l.name}>
                    <button onClick={() => go(l.href)} className="text-left text-sm text-cream/70 transition-colors hover:text-gold-bright">
                      {l.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Legal */}
          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-cream/50">Legal</h4>
            <ul className="mt-4 space-y-3">
              <li><a href="#" className="text-sm text-cream/70 transition-colors hover:text-gold-bright">Privacy Policy</a></li>
              <li><a href="#" className="text-sm text-cream/70 transition-colors hover:text-gold-bright">Terms of Service</a></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-3 border-t border-cream/10 py-6 text-sm text-cream/45 md:flex-row">
          <p>© {year} CrateWeb. ABN 93 507 692 151.</p>
          <p>Web design and maintenance for Melbourne small businesses.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
